export const externalLinkCodes = {
  TRMCND: 'TRMCND',
  INFPRVC: 'INFPRVC',
  INFO: 'INFO',
}

export const externalLinksCodesToShowInLoginForm = [externalLinkCodes.TRMCND, externalLinkCodes.INFPRVC]

export const ExternalClientLinks = {
  [externalLinkCodes.TRMCND]: $localize`Condizioni generali di contratto`,
  [externalLinkCodes.INFPRVC]: $localize`Informativa privacy`,
  [externalLinkCodes.INFO]: $localize`la pagina dedicata`,
}
